import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

interface AnalysisProgressProps {
  status?: 'idle' | 'running' | 'completed' | 'error';
  progress?: number;
  message?: string;
  className?: string;
}

const AnalysisProgress: React.FC<AnalysisProgressProps> = ({
  status = 'idle',
  progress = 0,
  message = '',
  className = ''
}) => {
  const getStatusIcon = () => {
    switch (status) {
      case 'running':
        return <Clock className="w-5 h-5 text-accent-tertiary animate-spin" />;
      case 'completed':
        return <CheckCircle className="w-5 h-5 text-green-500" />;
      case 'error':
        return <AlertCircle className="w-5 h-5 text-red-500" />;
      default:
        return <Clock className="w-5 h-5 text-theme-primary" />;
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'running': return 'bg-accent-tertiary';
      case 'completed': return 'bg-green-500';
      case 'error': return 'bg-red-500';
      default: return 'bg-gray-300';
    }
  };

  return (
    <div className={`analysis-progress p-4 bg-theme-surface rounded-lg border border-theme ${className}`}>
      <div className="flex items-center gap-3 mb-3">
        {getStatusIcon()}
        <h3 className="font-semibold text-neutral-100">
          {status === 'running' ? 'Analyse en cours...' :
           status === 'completed' ? 'Analyse terminée' :
           status === 'error' ? 'Erreur d\'analyse' :
           'En attente'}
        </h3>
      </div>
      
      {status === 'running' && (
        <div className="mb-3">
          <div className="w-full bg-theme-elevated rounded-full h-2">
            <div 
              className={`h-2 rounded-full transition-all duration-300 ${getStatusColor()}`}
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="text-sm text-theme-primary mt-1">{progress}%</div>
        </div>
      )}
      
      {message && (
        <p className="text-sm text-theme-primary">{message}</p>
      )}
    </div>
  );
};

export default AnalysisProgress;